//@@ Utils
import {
  canViewMenuGroup,
  canViewMenuItem,
  resolveHorizontalNavMenuItemComponent as resolveNavItemComponent
} from '@layouts/utils'

//@@ Components
import HorizontalNavMenuLink from './HorizontalNavMenuLink'
import HorizontalNavMenuGroup from './HorizontalNavMenuGroup'

const HorizontalNavMenuItems = (props) => {
  //@@ Components Object
  const Components = {
    HorizontalNavMenuGroup,
    HorizontalNavMenuLink
  }

  //@@ Render Nav Items
  return props.items.map((item, index) => {
    const TagName = Components[resolveNavItemComponent(item)]
    if (item.children) {
      return canViewMenuGroup(item) && <TagName item={item} index={index} key={item.id} {...props} />
    }
    return canViewMenuItem(item) && <TagName item={item} index={index} key={item.id} {...props} />
  })
}

export default HorizontalNavMenuItems
